import React from 'react';
import { ElvaPageLoader } from '../ElvaPageLoader/ElvaPageLoader';
import type { PuAiSummary, PuPatient, PuPractice, PuUnscheduledTreatment } from '../../patient-urgency/types';
import {
  PatientUrgencyAISummary,
  PatientUrgencyBookingCTA,
  PatientUrgencyFooter,
  PatientUrgencyHero,
  PatientUrgencyPracticeHeader,
  PatientUrgencyTreatmentsList,
} from './PatientUrgencySections';
import { puContainer, puRoot } from './puClasses';

export interface PatientUrgencyPageProps {
  patient?: PuPatient;
  practice?: PuPractice;
  aiSummary?: PuAiSummary;
  treatments?: PuUnscheduledTreatment[];
}

function PatientUrgencyMain({
  patient,
  practice,
  aiSummary,
  treatments,
}: Required<PatientUrgencyPageProps>) {
  return (
    <div className={puRoot}>
      <div className={puContainer}>
        <PatientUrgencyPracticeHeader practice={practice} />
        <PatientUrgencyHero patient={patient} />
        <PatientUrgencyAISummary summary={aiSummary} practiceName={practice.name} />
        <PatientUrgencyTreatmentsList treatments={treatments} />
        <PatientUrgencyBookingCTA practice={practice} />
        <PatientUrgencyFooter practice={practice} />
      </div>
    </div>
  );
}

export function PatientUrgencyPage({
  patient,
  practice,
  aiSummary,
  treatments,
}: PatientUrgencyPageProps) {
  if (!patient || !practice || !aiSummary || !treatments) {
    return (
      <div className={`${puRoot} flex min-h-screen items-center justify-center`}>
        <ElvaPageLoader />
      </div>
    );
  }

  return (
    <PatientUrgencyMain
      patient={patient}
      practice={practice}
      aiSummary={aiSummary}
      treatments={treatments}
    />
  );
}
